<script setup>
import axios from "axios";
import { useStore } from "vuex";
import SideBar from "../blocks/SideBar.vue";
import HeaderAcc from "../blocks/HeaderAcc.vue";
import FooterAccBar from "../blocks/FooterAccBar.vue";
import { onBeforeUnmount, onMounted, ref, computed, watch, defineAsyncComponent } from "vue";
import { useRoute } from "vue-router";

const store = useStore();
const route = useRoute();
const userProfile = ref(null);
const user = store.state.user;

const role = user.role?.item_name;
const themeId = computed(() => store.getters['getUser']);

watch(themeId, () => {
  getUser();
});

// 🔹 Загружаем профиль пользователя
async function getUser() {
  
  
  const params = {
    action: "user-profiles/" + user.profile.id,
    method: "GET",
    token: user.bearer,
  };
  const formData = new FormData();
  for (let key in params) {
    formData.append(key, params[key]);
  }
  try {
    const response = await axios.post(store.state.apiUrl, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    
    if (response.data) {
      userProfile.value = response.data; 
    }
  } catch (error) {
    console.error(error);
  }
}

// 🔹 Выбираем нужный компонент для `/account/profile`
const dynamicComponent = computed(() => {
  if (route.path === '/account/profile') {
    if (role === 'specialist') {
      return defineAsyncComponent(() => import('@/components/blocks/AccountSpecialistProfile.vue'));
    } else if (role === 'school') {
      return defineAsyncComponent(() => import('@/components/blocks/school/AdminProfileEducation.vue'));
    } else if (role === 'company') {
      return defineAsyncComponent(() => import('@/components/blocks/company/AdminProfileCompany.vue'));
    }
  }

  return null;
});

// 🔹 Обработчики адаптивности
const isSidebarVisible = ref(window.innerWidth >= 1200);
const isMobile = ref(window.innerWidth < 1200);

function updateSidebarVisibility() {
  isSidebarVisible.value = window.innerWidth >= 1200;
}

function updateMobileState() {
  isMobile.value = window.innerWidth < 1200;
}

onMounted(async () => {
  await getUser();
  window.addEventListener("resize", updateSidebarVisibility);
  window.addEventListener("resize", updateMobileState);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateSidebarVisibility);
  window.removeEventListener("resize", updateMobileState);
});
</script>

<template>
  <div class="wrapperAcc">
    <SideBar :role="role" :user="userProfile" v-if="isSidebarVisible && role" />
    <div class="info">
      <div class="wrapAccInfo">
        <HeaderAcc :user="userProfile" />
        <div class="account">
          <component v-if="dynamicComponent" :is="dynamicComponent" />
          
          <router-view v-else v-slot="{ Component }">
            <KeepAlive>
              <component :is="Component" />
            </KeepAlive>
          </router-view>
        </div>
      </div>
      <FooterAccBar :role="role" :user="userProfile" v-if="isMobile" />
    </div>
  </div>
</template>
<style scoped>
.wrapperAcc {
  display: flex;
  background: #f5f7f8;
}

.info {
  width: 100%;
  overflow: hidden;
}
.wrapAccInfo{
  padding-left: 30px;
  padding-right: 30px;
  margin-bottom: 60px;
}
.account {
  background: #fff;
  border-radius: 15px;
  padding: 30px;
  width: 100%;
}
@media (max-width: 1200px) {
  .account {
    padding: 15px 15px 25px;
  }
}
@media (max-width: 1200px) {
  .wrapAccInfo {
    padding-left: 10px;
    padding-right: 10px;
    margin-bottom: 90px;
  }
}
</style>